import TemplateView from '../../../TemplateView'

export default class SortButton extends TemplateView
{
    constructor({
        active = false,
        asc = false,
        titleLabel = '',
        onClick = () => {},
    } = {}) {
        super()

        this.params = {
            active,
            asc,
            titleLabel,
            onClick,
        }
    }

templateHtml() 
{
    return "<div class='sortButton'>" +
           "  <span class='titleLabel'><%-titleLabel%></span>" +
           "  <div class='arrowContainer'>" +
           "    <div class='ascArrow'><img src='<%=ascArrow%>'/> <span class='for-print-only'>&darr;</span></div>" +
           "    <div class='descArrow'><img src='<%=descArrow%>'/> <span class='for-print-only'>&uarr;</span></div>" +
           "  </div>" +
           "</div>"
}

    afterRender()
    {
        this.bindClick(this._onClick);
    }
    
    update()
    {
        this.$el.toggleClass("active", this.params.active);
        this.$el.toggleClass("asc", this.params.asc);
        this.$el.toggleClass("desc", !this.params.asc);
    }
    
    templateModel()
    {
        return {
            ascArrow: atImgPath("arrow-down.png"),
            descArrow: atImgPath("arrow-up.png")
        }
    }

    messageKeys()
    {
        return {titleLabel: this.params.titleLabel}
    }

    isActive()
    {
        return this.params.active;
    }

    setActive(active)
    {
        this.params.active = active;
        this.update();
    }

    isAsc()
    {
        return this.params.asc;
    }

    _onClick()
    {
        if (!this.params.active)
            this.params.active = true;
        else
            this.params.asc = !this.params.asc;

        this.update();
        this.params.onClick();
    }
}


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/SortButton.js